import type { ColumnFiltersState, PaginationState, SortingState } from '@tanstack/react-table';

export function serverTableParams<S extends string = string>(
  pagination: PaginationState,
  sorting: SortingState
) {
  return {
    limit: pagination.pageSize,
    offset: pagination.pageIndex * pagination.pageSize,
    sort: sorting.map((s) => `${s.desc ? '-' : '+'}${s.id}` as S),
  };
}

export type FilterConfig = Record<string, string | [string, string]>;

function applyFilter(
  params: Record<string, unknown>,
  mapping: string | [string, string],
  value: unknown
) {
  if (Array.isArray(mapping)) {
    const { from, to } = value as { from?: string; to?: string };
    if (from) params[mapping[0]] = from;
    if (to) {
      // Add one day to the "to" date to make the filter inclusive
      const toDate = new Date(to);
      toDate.setUTCDate(toDate.getUTCDate() + 1);
      params[mapping[1]] = toDate.toISOString();
    }
    return;
  }

  if (mapping.endsWith('In') && typeof value === 'string') {
    const items = value
      .split(',')
      .map((v) => v.trim())
      .filter(Boolean);
    if (items.length > 0) params[mapping] = items;
  } else {
    params[mapping] = value;
  }
}

export function buildFilterParams(filters: ColumnFiltersState, config: FilterConfig) {
  const params: Record<string, unknown> = {};
  for (const { id, value } of filters) {
    if (value == null) continue;
    if (typeof value === 'string' && !value.trim()) continue;
    if (config[id]) applyFilter(params, config[id], value);
  }
  return params;
}
